/* ============================================================
   API ฝั่งลูกค้า (/portal) — axios แยกจากของพนักงาน token เก็บคนละ key
   ลูกค้า login ที่หน้า /login เดียวกับพนักงาน (pages/Login.js) แล้วถูกพามาที่ /portal
============================================================ */
import axios from "axios";
import { BACKEND_URL } from "../utils/util";

export const PORTAL_TOKEN_KEY = "ak_portal_token";

export const portalToken = {
  get: () => {
    try {
      return localStorage.getItem(PORTAL_TOKEN_KEY);
    } catch (e) {
      return null;
    }
  },
  set: (t) => {
    try {
      localStorage.setItem(PORTAL_TOKEN_KEY, t);
    } catch (e) {}
  },
  clear: () => {
    try {
      localStorage.removeItem(PORTAL_TOKEN_KEY);
    } catch (e) {}
  },
};

const papi = axios.create({ baseURL: `${BACKEND_URL}/portal` });

papi.interceptors.request.use((config) => {
  const t = portalToken.get();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

papi.interceptors.response.use(
  (r) => r,
  (err) => {
    /* token หมดอายุ / ถูกปิด / เปลี่ยนรหัสจากที่อื่น → กลับหน้า login */
    if (err?.response?.status === 401) {
      portalToken.clear();
      if (window.location.pathname !== "/login") {
        const msg = err.response?.data?.message;
        window.location.replace(`/login${msg ? `?m=${encodeURIComponent(msg)}` : ""}`);
      }
    }
    return Promise.reject(err);
  }
);

const toForm = (fields, files) => {
  const fd = new FormData();
  Object.entries(fields).forEach(([k, v]) => v !== undefined && v !== null && fd.append(k, v));
  (files || []).forEach((f) => fd.append("files[]", f.originFileObj || f));
  return fd;
};

export const Portal = {
  me: () => papi.get("/me.php"),
  changePassword: (old_password, new_password) => papi.post("/me.php", { old_password, new_password }),
  projects: () => papi.get("/projects.php"),
  project: (code) => papi.get("/projects.php", { params: { code } }),
  rc: (code) => papi.get("/rc.php", { params: { code } }),
  createRc: (fields, files) => papi.post("/rc.php", toForm(fields, files)),
  replyRc: (fields, files) => papi.post("/rc.php", toForm(fields, files)),
  cancelRc: (rc_code) => papi.patch("/rc.php", { rc_code, action: "cancel" }),
  file: (kind, id, inline) => papi.get("/file.php", { params: { kind, id, inline: inline ? 1 : undefined }, responseType: "blob" }),
};

export const perr = (e, fb = "เกิดข้อผิดพลาด กรุณาลองใหม่") => e?.response?.data?.message || fb;
export default papi;
